var _path, _rect, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnderevaluation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4046 7.79018C15.4046 12.0095 11.9841 15.43 7.76478 15.43C3.54544 15.43 0.125 12.0095 0.125 7.79018C0.125 3.57083 3.54544 0.150391 7.76478 0.150391C11.9841 0.150391 15.4046 3.57083 15.4046 7.79018Z",
    fill: "#917AFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12.0963,
    height: 3.18324,
    transform: "translate(2.03418 6.51758)",
    fill: "#917AFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21742 8.1092C5.21742 8.98823 4.50483 9.70082 3.6258 9.70082C2.74677 9.70082 2.03418 8.98823 2.03418 8.1092C2.03418 7.23017 2.74677 6.51758 3.6258 6.51758C4.50483 6.51758 5.21742 7.23017 5.21742 8.1092Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67348 8.1092C9.67348 8.98823 8.96089 9.70082 8.08186 9.70082C7.20283 9.70082 6.49023 8.98823 6.49023 8.1092C6.49023 7.23017 7.20283 6.51758 8.08186 6.51758C8.96089 6.51758 9.67348 7.23017 9.67348 8.1092Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1305 8.1092C14.1305 8.98823 13.4179 9.70082 12.5389 9.70082C11.6599 9.70082 10.9473 8.98823 10.9473 8.1092C10.9473 7.23017 11.6599 6.51758 12.5389 6.51758C13.4179 6.51758 14.1305 7.23017 14.1305 8.1092Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderevaluation);
export default __webpack_public_path__ + "static/media/underevaluation.ba165ab12c2493d9e106df2d51e87015.svg";
export { ForwardRef as ReactComponent };